// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_az-0";
export var orangeButton = "_az-1";